import { m } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { optimizedViewport } from "@/lib/motion";
import ContactForm from "@/components/ContactForm";

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-primary/10 blur-[150px]" />
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <m.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={optimizedViewport} transition={{ duration: 0.6 }} className="text-center mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            {t("cta.title")} <span className="text-gradient">{t("cta.titleHighlight")}</span>?
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">{t("cta.subtitle")}</p>
        </m.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 max-w-6xl mx-auto">
          <m.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={optimizedViewport} transition={{ duration: 0.5 }} className="lg:col-span-2 flex flex-col gap-6 justify-center">
            <div className="glass rounded-xl p-6 flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center shrink-0">
                <Phone className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="font-heading font-semibold mb-1">{t("cta.phone")}</h3>
                <a href="tel:+420724301099" className="text-muted-foreground hover:text-primary transition-colors">+420 724 301 099</a>
              </div>
            </div>
            <div className="glass rounded-xl p-6 flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center shrink-0">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="font-heading font-semibold mb-1">{t("cta.email")}</h3>
                <a href="mailto:info@ekokompakt.cz" className="text-muted-foreground hover:text-primary transition-colors">info@ekokompakt.cz</a>
              </div>
            </div>
            <div className="glass rounded-xl p-6 flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="font-heading font-semibold mb-1">{t("cta.address")}</h3>
                <p className="text-muted-foreground">{t("cta.addressValue")}</p>
              </div>
            </div>
          </m.div>
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
